<template>
  <div class="version-container">
    <div
      v-for="item in version"
      :key="item.num">
      <div style="margin-bottom: 10px;">
        <p style="margin: 0">{{ item.num }}</p>
        <p v-for="(cont, index) in item.cont" :key="index" style="margin: 0;text-indent: 15px;font-size: 14px;">{{ cont }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Version',
  data() {
    return {
      version: [{
        num: 'V0.0.15',
        cont: ['1.download页面增加重定向（BrandBin-2023/09/14）']
      }, {
        num: 'V0.0.14',
        cont: ['1.网络电话测试（BrandBin-2023/02/28）']
      }, {
        num: 'V0.0.13',
        cont: ['1.增加用户, 隐私, 儿童隐私协议（Variations-2022/11/15）']
      }, {
        num: 'V0.0.12',
        cont: ['1.增加隐私协议（BrandBin-2022/07/18）']
      }, {
        num: 'V0.0.11',
        cont: ['1.首页增加小程序跳转（BrandBin-2021/05/21）']
      }, {
        num: 'V0.0.10',
        cont: ['1.借阅记录增加参数/扫码登录优化提示（BrandBin-2021/05/21）']
      }, {
        num: 'V0.0.9',
        cont: ['1.增加借阅记录页面（BrandBin-2021/04/27）']
      }, {
        num: 'V0.0.8',
        cont: ['1.增加演示课件（无需登录）（BrandBin-2021/03/05）']
      }, {
        num: 'V0.0.7',
        cont: ['1.增加退出功能（BrandBin-2021/03/05）']
      }, {
        num: 'V0.0.6',
        cont: ['1.vuex状态存储方式更改为localStorage（BrandBin-2021/02/20）']
      }, {
        num: 'V0.0.5',
        cont: ['1.课件标题显示优化（BrandBin-2021/02/06）']
      }, {
        num: 'V0.0.4',
        cont: ['1.增加课件演示（BrandBin-2021/01/07）']
      }, {
        num: 'V0.0.3',
        cont: ['1.增加APP下载页面（BrandBin-2020/10/30）']
      }, {
        num: 'V0.0.2',
        cont: ['1.背景图更换（BrandBin-2020/09/30）']
      }, {
        num: 'V0.0.1',
        cont: ['1.基础版本（BrandBin-2020/09/30）']
      }]
    }
  }
}
</script>

<style scoped>

</style>
